import { useEffect, useMemo } from "react";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { retrieveConvergencePageMenu } from "../../redux/slice/convergence/convergence-pages-menu-slice";
import { RootState, useAppDispatch } from "../../redux/store";
import logo from "../../assets/images/RAPS-Logo.png";
import { retrieveUserInfo } from "../../redux/slice/sso/userinfo.slice";
import useAuth from "../../hooks/useAuth";
import LoadAds from "../../components/advertisement/load-europe-convergence-ads";

const EuropeHeader = () => {
  const auth = useAuth();

  const dispatch = useAppDispatch();
  const path = "%2Feurope-2024%2FSite-Nav";
  const { ConvergencePagesMenuData } = useSelector((state: RootState) => state.ConvergencePageMenu);
  const { checkLogin } = useSelector((state: RootState) => state.loggedIn);
  const cachedGoogleAdsLoader = useMemo(() => <LoadAds />, []);

  const userInfo = useSelector((state: RootState) => state.userInfo);
  const userInfoData = userInfo.data;

  useEffect(() => {
    dispatch(retrieveConvergencePageMenu(path));
  }, [dispatch]);

  useEffect(() => {
    if (!userInfo.loading && auth.getUser()?.accessToken && userInfo.data?.result === undefined) {
      dispatch(retrieveUserInfo());
    }
  }, [dispatch]);

  return (
    <>
      {/*cachedGoogleAdsLoader*/}
      <Navbar bg="dark" className="bg-primary sticky-top navbar-dark" expand="lg">
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            {ConvergencePagesMenuData[0]?.navBarItemsList?.map((item, index) => {
              return item.childNavigation?.length === 0 ? (
                <Nav.Link href={item.url} key={index} target={item.isTargetBlank ? "_blank" : ""} dangerouslySetInnerHTML={{ __html: item.text }}></Nav.Link>
              ) : (
                <NavDropdown id={"nav-dropdown-dark-example-" + index} title={item.text} menuVariant="dark" key={index} renderMenuOnMount={true}>
                  {item.childNavigation?.map((itm, indx) => {
                    return <NavDropdown.Item href={itm.url} key={indx} target={itm.isTargetBlank ? "_blank" : ""} dangerouslySetInnerHTML={{ __html: itm.text }}></NavDropdown.Item>;
                  })}
                </NavDropdown>
              );
            })}
          </Nav>
        </Navbar.Collapse>
        <div className="form-inline">
          {checkLogin.isLoggedIn && userInfoData.result && <span className="navbar-brand greeting">Hi, {userInfoData.result?.firstName}</span>}
          <Link className="navbar-brand" style={{ marginRight: 0 }} to="/">
            <img alt="RAPS.org" src={logo} />
          </Link>
        </div>
      </Navbar>
    </>
  );
};

export default EuropeHeader;